<div class="auth-wrapper">
  <mat-card class="auth-card" appearance="outlined">
    <mat-card-content class="auth-content">
      <h1 class="headline">{{ 'termsAcceptance.headline' | transloco }}</h1>
      <p class="supporting">{{ 'termsAcceptance.supporting' | transloco }}</p>

      @if (loading) {
        <div class="terms-loading" role="status" aria-live="polite">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      }

      @if (loadError) {
        <p class="error" role="alert">{{ 'termsAcceptance.loadError' | transloco }}</p>
      }

      @if (!loading && !loadError && pendingTerms.length > 0) {
        <div class="terms-list">
          @for (term of pendingTerms; track term.id) {
            <div class="term-row">
              <mat-checkbox
                [checked]="isTermAccepted(term.id)"
                (change)="toggleTerm(term.id, $event.checked)">
                {{ term.resume }}
                @if (term.kind === 'permission') {
                  <span class="term-optional">&nbsp;({{ 'signup.terms.optional' | transloco }})</span>
                }
              </mat-checkbox>
              <button mat-button type="button" class="term-read-more"
                      (click)="openFullText(term)">
                {{ 'signup.terms.readFullText' | transloco }}
              </button>
            </div>
          }
        </div>

        <button mat-flat-button color="primary" type="button"
                [disabled]="submitting || hasUnacceptedMandatoryTerm"
                (click)="submit()">
          @if (submitting) {
            {{ 'termsAcceptance.submit.submitting' | transloco }}
          } @else {
            {{ 'termsAcceptance.submit.idle' | transloco }}
          }
        </button>
      }
    </mat-card-content>
  </mat-card>
</div>
